import { Component, Input } from '@angular/core';
import { Series } from '@swimlane/ngx-charts';
import { ChartAction } from '../chart/chart.component';

export interface GroupedChartData extends Series {}

@Component({
  selector: 'app-grouped-chart',
  templateUrl: './grouped-chart.component.html',
  styleUrls: ['./grouped-chart.component.scss'],
})
export class GroupedChartComponent {
  @Input('label') public label: string = '';
  @Input('actions') public actions: Array<ChartAction> = [];
  @Input('data') public data: Array<GroupedChartData> = [];

  constructor() {}
}
